import { createBrowserRouter } from 'react-router-dom';

import AppLayout from './components/app-layout/index';
import { AuthGuard } from './guards/index';
import Companies from './pages/companies/index';
import { Perks } from './pages/content/perks/index';
import { Templates } from './pages/content/templates/index';
import Dashboard from './pages/dashboard/index';
import Error from './pages/error/index';
import Home from './pages/home/index';
import Login from './pages/login/index';
import Logs from './pages/logs/index';
import Settings from './pages/settings/index';
import Stakeholders from './pages/stakeholders/index';
import { Team } from './pages/team/index';
import { PageRoute } from './types/page.types';

const router = createBrowserRouter([
  {
    path: PageRoute.HOME,
    element: (
      <AuthGuard>
        <AppLayout>
          <Home />
        </AppLayout>
      </AuthGuard>
    ),
  },
  {
    path: PageRoute.CONTENT_TEMPLATES,
    element: (
      <AuthGuard>
        <AppLayout>
          <Templates />
        </AppLayout>
      </AuthGuard>
    ),
  },
  {
    path: PageRoute.CONTENT_PERKS,
    element: (
      <AuthGuard>
        <AppLayout>
          <Perks />
        </AppLayout>
      </AuthGuard>
    ),
  },
  {
    path: PageRoute.DASHBOARD,
    element: (
      <AuthGuard>
        <AppLayout>
          <Dashboard />
        </AppLayout>
      </AuthGuard>
    ),
  },
  {
    path: PageRoute.COMPANIES,
    element: (
      <AuthGuard>
        <AppLayout>
          <Companies />
        </AppLayout>
      </AuthGuard>
    ),
  },
  {
    path: PageRoute.STAKEHOLDERS,
    element: (
      <AuthGuard>
        <AppLayout>
          <Stakeholders />
        </AppLayout>
      </AuthGuard>
    ),
  },
  {
    path: PageRoute.TEAM,
    element: (
      <AuthGuard>
        <AppLayout>
          <Team />
        </AppLayout>
      </AuthGuard>
    ),
  },
  {
    path: PageRoute.LOGS,
    element: (
      <AuthGuard>
        <AppLayout>
          <Logs />
        </AppLayout>
      </AuthGuard>
    ),
  },
  {
    path: PageRoute.SETTINGS,
    element: (
      <AuthGuard>
        <AppLayout>
          <Settings />
        </AppLayout>
      </AuthGuard>
    ),
  },
  {
    path: PageRoute.LOGIN,
    element: <Login />,
  },
  {
    path: PageRoute.ERROR,
    element: <Error />,
  },
]);

export default router;
